import * as React from "react";
const SvgSearch = () => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, fill: "none" }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.8 2.5a4.3 4.3 0 1 0 0 8.6 4.3 4.3 0 0 0 0-8.6m4.085 7.678a5.3 5.3 0 1 0-.707.707l3.468 3.469a.5.5 0 0 0 .708-.708z",
    clipRule: "evenodd"
  }
));
export default SvgSearch;
